export interface Metafield {
  value_type: string;
  key: string;
  namespace: string;
  description: string;
}
export class Listing {
  _id?: string;
  id?: string;
  __v: number;
  title: string;
  category: string;
  description: string;
  sku: string;
  price: number;
  suggested_retail_price: number;
  compare_at_price: number;
  original_price: number;
  main_image: string;
  thumbnail_url: string;
  iso_currency_code: string;
  url: string;
  barcode: string;
  default_variant_option: {
    id: string;
    title: string;
    sku: string;
    price: number;
    suggested_retail_price: number;
    original_price: number;
    compare_at_price: number;
    price_diff: number;
    stock: number;
    barcode: string;
  };
  stock: number;
  quantity?: number;
  vendor: string;
  variations: any[];
  images: string[];
  metafields: Metafield[];
  status: string;
  in_stock: boolean;

  static default(): Listing {
    let listing = new Listing();
    listing.category = "My Category";
    listing.sku = "" + new Date().getTime();
    listing.title = "My Title";
    listing.description = "My Description";
    listing.barcode = "102932090";
    listing.price = 10;
    listing.suggested_retail_price = 10;
    listing.stock = 1;
    listing.iso_currency_code = "USD";
    listing.images = [];
    listing.variations = [
      {
        title: "Colors",
        options: [
          {
            title: "Red",
            sku: "SKU 0",
            barcode: "102932091",
            price: 10,
            suggested_retail_price: 10,
            stock: 1,
          },
          {
            title: "Blue",
            sku: "SKU 1",
            barcode: "102932092",
            price: 10,
            suggested_retail_price: 10,
            stock: 1,
          },
        ],
      },
    ];
    return listing;
  }
}

export class Category {
  id: string;
  title?: string;
  name?: string;
  isCustomCollection: boolean;
}
